import { useParams } from 'react-router';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { PolicyPagePrefetchedDataProps } from 'src/app/pages/legal/policy/pageContext';
import { PolicyPageContextProvider, prefetchPageContext } from 'src/app/pages/legal/policy/pageContext';

import { Layout } from '../layout';

import { PolicyErrorHandler } from './ErrorHandler';

export const Policy = withPrefetchedData(
	function Policy({ prefetchedData }: PolicyPagePrefetchedDataProps) {
		const { slug } = useParams();

		return (
			<PolicyPageContextProvider
				slug={slug}
				prefetchedData={prefetchedData}
				errorHandler={PolicyErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</PolicyPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context.params.slug, context),
	},
);
